import { render } from "./WarnAuth.vue?vue&type=template&id=f6d921e8"
import script from "./WarnAuth.vue?vue&type=script&lang=js"
export * from "./WarnAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__